<template>
    <div class="account-card-report">
        <form @submit.prevent="getData">
            <date-picker v-model="startDate" :title="$t('ACCOUNT_CARDS__START_DATE')" @clear="startDate = ''" />
            <date-picker v-model="toDate" :title="$t('ACCOUNT_CARDS__TO_DATE')" @clear="toDate = ''" />
            <switcher :title="$t('ACCOUNT_CARDS__OMIT_GAME_OPERATIONS')" v-model="omitGameOperations" />
            <button class="btn">{{ $t('ACCOUNT_CARDS__SEARCH') }}</button>
        </form>
        <div class="loader" v-show="loading"></div>
        <grid
            v-show="!loading"
            fullGrid
            :passedData="gridData"
            :columns="columns"
            :passedCount="count"
            :passedPageSize="pageSize"
            @pageChanged="pageChangeHandler"
        />
    </div>
</template>

<script>
import DatePicker from '@/components/ReusableComponents/DatePicker/DatePicker.vue'
import Switcher from '@/components/ReusableComponents/Switcher/Switcher.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { subtractHours, addHours } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        DatePicker,
        Grid,
        Switcher,
    },
    props: {
        cardID: {
            type: Number,
            required: true,
        },
        currency: String,
    },
    created() {
        this.getData()
    },
    data() {
        return {
            startDate: '',
            toDate: '',
            currentPage: 1,
            pageSize: 10,
            gridData: [],
            count: 0,
            columns: [
                {
                    title: this.$t('ACCOUNT_CARDS__CREATION_TIME'),
                    key: 'createTime',
                    customTemplate: (item, val) =>
                        addHours(val, 2),
                },
                {
                    title: this.$t('ACCOUNT_CARDS__ACTION'),
                    key: 'action',
                },
                {
                    title: this.$t('ACCOUNT_CARDS__APPLICATION'),
                    key: 'application',
                },
                {
                    title: this.$t('ACCOUNT_CARDS__AMOUNT'),
                    key: 'amount',
                    customTemplate: (item, val) => val.toFixed(2) + ' ' + this.currency,
                },
                {
                    title: '',
                    key: 'sportsBookBetId',
                    customTemplate: (item, val) => val 
                        ? `<a href="/Sportsbook/${val}/${this.cardID}" target="_blank"><button class="btn details">${this.$t('ACCOUNT_CARDS__DETAILS')}</button></a>`
                        : ''
                }
            ],
            omitGameOperations: true,
            loading: false,
        }
    },
    methods: {
        getData() {
            this.loading = true
            var toDate = new Date(this.toDate)
            toDate.setDate(toDate.getDate() + 1) // add one day
            toDate = this.toDate ? subtractHours(toDate, 2) : ''
            axios
                .get('WebShop/GetUserTransactions', {
                    params: {
                        AccountCardId: this.cardID,
                        StartDate: subtractHours(this.startDate, 2),
                        ToDate: toDate,
                        CurrentPage: this.currentPage,
                        PageSize: this.pageSize,
                        OmitGameOperations: this.omitGameOperations,
                    },
                })
                .then(resp => {
                    if (resp.data.response.length > 0) {
                        this.count = resp.data.response[0].count
                    }
                    this.gridData = resp.data.response
                    this.loading = false
                })
        },
        pageChangeHandler(page) {
            this.currentPage = page
            this.getData()
        },
    },
}
</script>

<style lang="scss" scoped>
form {
    margin: 30 * $rem 0;
    display: flex;
    align-items: center;

    label,
    .switcher-container,
    .btn {
        margin-right: 15 * $rem;
        width: 100%;
        height: 40 * $rem;
    }
}

h3 {
    font-size: 24 * $rem;
    text-align: center;
}

/deep/ .btn {
    min-width: initial;
    min-height: initial;
    width: 80 * $rem;
    height: 34 * $rem;
}

@media only screen and (max-width: 1000px) {
    form {
        flex-wrap: wrap;

        label,
        .switcher-container,
        .btn {
            margin-top: 15 * $rem;
            width: calc(50% - #{15 * $rem});
        }
    }
}

@media only screen and (max-width: 510px) {
    form {
        label,
        .switcher-container,
        .btn {
            margin-top: 15 * $rem;
            margin-right: 0;
            width: 100%;
        }
    }
}
</style>